"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DelFile = exports.FileName = exports.UploadFileList = exports.HiddenInput = exports.DropzoneStyled = exports.DocSubmitButton = exports.ModalDocDiv = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const HomePageAll_1 = require("../StyledComponents/HomePageAll");
const themeUtils_1 = require("../../themes/themeUtils");
exports.ModalDocDiv = styled_components_1.default.div `
  padding-top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
exports.DocSubmitButton = (0, styled_components_1.default)(HomePageAll_1.MyBlueButton) `
  margin-top: 15px;
`;
exports.DropzoneStyled = styled_components_1.default.div `
  flex: 0;
  &.custom {
    display: flex;
    justify-content: space-around;
    align-items: center;
    background: inherit;
    width: 121px;
    height: 35px;
    border-radius: 4px;
    box-shadow: 0 0 6px 0 ${({ theme }) => (0, themeUtils_1.applyOpacityToHex)(theme.palette.text.strong, 0.15)};
    overflow: hidden;
    cursor: pointer;
  }
  &:focus-within {
    background: ${({ theme }) => theme.palette.background.paper};
    text-decoration: underline;
  }
`;
exports.HiddenInput = styled_components_1.default.input `
  position: fixed;
  height: 2px;
  width: 2px;
  opacity: 0;
`;
exports.UploadFileList = styled_components_1.default.ul `
  list-style-type: none;
  padding-left: 0px;
  line-height: 20px;
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: 16px;
  li {
    cursor: pointer;
    display: inline-block;
    margin-right: 8px;
    border: solid 1px ${({ theme }) => theme.palette.background.elevated};
  }
  li:hover {
    border: solid 1px ${({ theme }) => theme.palette.text.tertiary};
  }
`;
exports.FileName = styled_components_1.default.p `
  display: inline;
  line-height: inherit;
  margin-left: 5px;
`;
exports.DelFile = (0, styled_components_1.default)(HomePageAll_1.CloseBox) `
  margin-right: 5px;
  cursor: pointer;
  position: relative;
  height: 15px;
  width: 15px;
  display: inline-block;
  vertical-align: center;
  margin: auto;
  float: left;
  padding: 2px 2px 2px 4px;
  font-size: 10px;
  line-height: 11px;
`;
